import { render, staticRenderFns } from "./AdminViewUser.vue?vue&type=template&id=d710d13c&scoped=true&"
import script from "./AdminViewUser.vue?vue&type=script&lang=js&"
export * from "./AdminViewUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewUser.vue?vue&type=style&index=0&id=d710d13c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d710d13c",
  null
  
)

export default component.exports